/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import DOMPurify from 'dompurify';

const useStyles = makeStyles(() => {
  return {
    contentWrapper: {
      display: 'flex',
      maxHeight: '800px',
      maxWidth: '800px',
      minHeight: '450px',
      minWidth: '550px',
      overflowY: 'auto',
      padding: '0 16px 32px 48px',
    },
    htmlModal: {
      overflowY: 'auto',
      paddingRight: '24px',
    },
  };
});

export default ({ content = '' }) => {
  const classes = useStyles();
  const cleanReport = DOMPurify.sanitize(content, { USE_PROFILES: { html: true } });

  return (
    <div className={`${classes.contentWrapper} table-container`}>
      <div className={classes.htmlModal} dangerouslySetInnerHTML={{ __html: cleanReport }} />
    </div>
  );
};
